import { Bot } from 'lucide-react';
import { OPTIBOT_GRADIENT } from '../utils/constants';

/**
 * OptiBot avatar — 28px green gradient circle with a bot icon.
 * Used next to assistant messages and the welcome message.
 */
export function BotAvatar() {
  return (
    <div
      className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full"
      style={{ background: OPTIBOT_GRADIENT }}
    >
      <Bot className="h-4 w-4 text-white" />
    </div>
  );
}
